module.exports = __webpack_public_path__ + "img/HistoryAnomalyDetection.0eb59bf4.png";